import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-phone\"><path d=\"M767.517 1023.033H256.482c-30.264 0-54.753-23.67-54.753-52.863V53.831c0-29.194 24.489-52.865 54.753-52.865h511.035c30.264 0 54.754 23.671 54.754 52.865v916.338c-.001 29.194-24.49 52.864-54.754 52.864zm-255.518-52.864c20.142 0 36.504-15.774 36.504-35.238s-16.362-35.255-36.504-35.255-36.5 15.793-36.5 35.255c0 19.464 16.359 35.238 36.5 35.238zm255.518-863.474H256.482v740.117h511.035V106.695z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol